import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'intersection-observer'; // Optional
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import cssVars from 'css-vars-ponyfill';
import 'viewerjs/dist/viewer.css';
import '../node_modules/vue-multiselect/dist/vue-multiselect.min.css';
import './assets/scss/main.scss';
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import "@hipsjs/flowy-vue/dist/lib/flowy-vue.css";


import Default from './views/layouts/Default';
import Login from './views/layouts/Login';
import Home from './views/layouts/Home';

import BootstrapVue from 'bootstrap-vue';
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import filters from './filters';
import { ability } from './store';
import api from './api';
import Notifications from 'vue-notification';
import RiskhubVueElementLoading from './components/Loader/RiskhubVueElementLoading.vue';
import VueElementLoading from 'vue-element-loading';
import VueProgressBar from 'vue-progressbar';
import Vuelidate from 'vuelidate';
import MultiSelect from 'vue-multiselect';
import VCalendar from 'v-calendar';
import Viewer from 'v-viewer';
import VueFormWizard from 'vue-form-wizard'
import { abilitiesPlugin } from '@casl/vue'
import permissions from '@/config/permission';
// Some common components that are globally accessed
import RiskhubForm from '@/components/Form/RiskhubForm';
import FormError from '@/components/Form/FormError';
import CaretIcon from '@/components/Form/CaretIcon';
import 'ag-grid-enterprise';
import { LicenseManager } from 'ag-grid-enterprise';
import PortalVue from 'portal-vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faSearch as falSearch,
  faUsers,
  faCheck,
  faTags,
  faStickyNote,
  faDownload,
  faFileDownload,
  faTimesCircle,
  faChevronDown,
  faChevronUp,
  faSpinner,
  faPlus,
  faTrash,
  faListOl,
  faPenAlt,
  faUpload,
  faFlag,
  faRedo,
  faFireExtinguisher,
  faVial,
  faBiohazard,
  faBolt,
  faWater,
  faBurn,
  faCalendarPlus,
  faCalendarMinus,
} from '@fortawesome/pro-light-svg-icons';
import {
  faArrowRight,
  faTimes,
  faCalendarAlt,
  faCog,
  faPencil,
  faSyncAlt,
  faExclamationCircle,
  faEnvelopeOpenText,
  faBan,
  faCamera,
  faChevronLeft,
  faChevronRight,
  faBars,
  faEye,
  faEyeSlash,
  faLevelUp,
  faQuestionCircle,
  faArrowLeft,
  faExternalLinkSquare,
  faInfoCircle,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faTasksAlt,
} from '@fortawesome/pro-solid-svg-icons';
import {
  faSearch,
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFileImage,
  faUserCircle,
  faAdjust,
  faChartBar,
  faUsers as fasUsers,
  faLock,
  faLockOpen,
  faTimesCircle as fasTimesCircle,
  faChevronDown as fasChevronDown,
  faFilter,
  faSave,
  faQuestionCircle as fasQuestionCircle,
  faCloudUploadAlt,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { Auth0Plugin } from '@/services/Auth';
import FlowyPlugin from "@hipsjs/flowy-vue";
import PendoPlugin from "@/plugins/pendo";

// add check to see if maintenance mode is enabled
(async () => {
  const maintenanceMode = await api.get('/maintenance-mode');
  if (maintenanceMode.data.enabled === true) {
    window.location.href = '/maintenance.html';
  }
})();

// Set global api
window.api = api;
Vue.use(Auth0Plugin, {
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
  redirectUri: process.env.VUE_APP_AUTH0_REDIRECT_URI,
  audience: process.env.VUE_APP_AUTH0_AUDIENCE,
  onRedirectCallback: (appState) => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname,
    );
  },
});


Vue.use(VueProgressBar, {
  color: '#4E738A',
  thickness: '2px',
});
Vue.use(BootstrapVue);
Vue.use(Notifications);
Vue.use(Vuelidate);
Vue.use(VCalendar, {
  locale: 'en-GB',
});
Vue.use(Viewer);
Vue.use(abilitiesPlugin, ability);
Vue.use(PortalVue);


Vue.use(VueFormWizard)
Vue.use(FlowyPlugin);

Vue.use(PendoPlugin, {
  id: process.env.VUE_APP_PENDO_ID,
  getUserData: () => store.getters['authUser'],
  getClientData: () => store.getters['userClient'],
  watchers: [
    (callback) => store.watch(
        (state, getters) => getters['userClientId'],
        callback
    ),
  ],
});

// Local components
Vue.component('form-error', FormError);
Vue.component('caret-icon', CaretIcon);
Vue.component('r-form', RiskhubForm);

// Third party components
LicenseManager.setLicenseKey(process.env.VUE_APP_AG_GRID_API_KEY);
Vue.component('multiselect', MultiSelect);
Vue.component('VueElementLoading', VueElementLoading);
Vue.component('RiskhubVueElementLoading', RiskhubVueElementLoading);
Vue.component('font-awesome-icon', FontAwesomeIcon);
library.add(
  falSearch,
  faUsers,
  faCheck,
  faTags,
  faStickyNote,
  faDownload,
  faFileDownload,
  faTimesCircle,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  faPencil,
  faSpinner,
  faFilePdf,
  faSearch,
  faArrowLeft,
  faArrowRight,
  faTimes,
  faCalendarAlt,
  faSyncAlt,
  faPlus,
  faTrash,
  faListOl,
  faPenAlt,
  faUpload,
  faFileImage,
  faFileWord,
  faFileExcel,
  faFlag,
  faExclamationCircle,
  faEnvelopeOpenText,
  faBan,
  faCamera,
  faRedo,
  faUserCircle,
  faAdjust,
  faChartBar,
  faTasksAlt,
  fasUsers,
  faQuestionCircle,
  fasQuestionCircle,
  faCog,
  faLock,
  faLockOpen,
  faBars,
  faEye,
  faEyeSlash,
  fasTimesCircle,
  fasChevronDown,
  faFilter,
  faFireExtinguisher,
  faVial,
  faBiohazard,
  faBolt,
  faWater,
  faBurn,
  faSave,
  faLevelUp,
  faArrowLeft,
  faExternalLinkSquare,
  faCloudUploadAlt,
  faInfoCircle,
  faCalendarPlus,
  faCalendarMinus,
);

// Layouts
Vue.component('default-layout', Default);
Vue.component('login-layout', Login);
Vue.component('home-layout', Home);

Vue.config.productionTip = false;

Vue.prototype.$perm = permissions;
Vue.prototype.$model = null;

const setWindowHeight = () => {
  cssVars({
    variables: {
      '--window-height': `${window.innerHeight}px`,
    },
  });
};

window.addEventListener('resize', () => {
  setWindowHeight();

  // yes i know, but because older ipads took their time setting the new
  // innerHeight on rotation, we have to do this again a 1/4 of a second later,
  // otherwise we get the old innerHeight, not the new one.
  setTimeout(setWindowHeight, 250);
});

setWindowHeight();


new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
